/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    FORGOT_title: "Forgot your password",
    FORGOT_intro: "Enter your email address. If an account exists, you will receive a link to "
        + "reset your password.",
    FORGOT_email: "Email",
    FORGOT_emailPlaceholder: "you@example.com",
    FORGOT_submit: "Send the link",
    FORGOT_sending: "Sending…",
    FORGOT_back: "Back to sign in",
    FORGOT_sentTitle: "Check your inbox",
    FORGOT_sentMessage: "If an account is associated with this address, an email with a reset link "
        + "has just been sent. The link expires in 30 minutes."
};
